import type { GetTweetById200Auth } from './getTweetById200Auth';
import type { GetTweetById200Author } from './getTweetById200Author';
import type { GetTweetById200BasicInfo } from './getTweetById200BasicInfo';
import type { GetTweetById200Engagement } from './getTweetById200Engagement';
import type { GetTweetById200Media } from './getTweetById200Media';
import type { GetTweetById200Poll } from './getTweetById200Poll';
import type { GetTweetById200ReferencedTweet } from './getTweetById200ReferencedTweet';
import type { GetTweetById200Tags } from './getTweetById200Tags';
import type { GetTweetById200UserInteraction } from './getTweetById200UserInteraction';

export type GetTweetById200 = {
  /** 인증 컨텍스트 정보 */
  auth?: GetTweetById200Auth;
  /** 트윗 작성자 정보 */
  author?: GetTweetById200Author;
  basicInfo?: GetTweetById200BasicInfo;
  engagement?: GetTweetById200Engagement;
  /** 미디어 정보 */
  media?: GetTweetById200Media;
  /** 트윗에 포함될 투표 정보 (선택 사항) */
  poll?: GetTweetById200Poll;
  /** 참조된 트윗 정보 (답글, 인용, 리트윗인 경우) */
  referencedTweet?: GetTweetById200ReferencedTweet;
  /** 트윗 태그 정보 */
  tags?: GetTweetById200Tags;
  /** 사용자 상호작용 정보 */
  userInteraction?: GetTweetById200UserInteraction;
};
